require('/opt/odin/app/frontend/pages/home/components/youtube_banner/index.module.scss');module.exports = "../../app/cells/pages/home/youtube_banner/show.erb";